import { forwardRef } from 'react';
import classNames from 'classnames';

import './List.scss';

const RefactoredSubList = forwardRef(
  ({ children, style, extraClassNames }, ref) => {
    return (
      <div
        ref={ref}
        className={classNames('r-list r-list--sublist', extraClassNames, {})}
        style={style}
      >
        {children}
      </div>
    );
  }
);

export default RefactoredSubList;
